import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { ApiResponseBody, ReduxRequestPassOptions } from 'types/request';

import Cart from 'models/Cart';

import {
    createCartItem, CreateCartItemParams,
} from 'store/modules/carts/actions';
import { State } from 'store/state';

import Component from './component';

export interface Props extends ParentProps {
    actions: {
        createCartItem: (params?: CreateCartItemParams, requestParams?: ReduxRequestPassOptions) => Promise<ApiResponseBody>;
    };
    state: {
        cart: Cart;
    }
}

import ListCollection from 'types/redux/ListCollection';

import Product from 'models/Product';

import { Props as ButtonProps } from 'components/layout/Button';

export interface ParentProps {
    buttonProps: {
        undo: ButtonProps;
        more: ButtonProps;
    };
    products: ListCollection<Product>
}

const mapStateToProps = (state: State, ownProps?: Props): object => {
    return {
        state: {
            cart: state?.cart?.data,
        },
    };
};

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            createCartItem: bindActionCreators(createCartItem, dispatch),
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
